// src/api/auth.ts
import { apiGet, apiPost } from "./client";
import type { AuthMe } from "../types/auth";

export interface LoginResponse {
  access_token: string;
  token_type: string;
  company_id: number;
}

export interface RegisterPayload {
  email: string;
  full_name: string;
  password: string;
}

// --- Core auth calls ---
export async function login(
  email: string,
  password: string
): Promise<LoginResponse> {
  return apiPost<LoginResponse>("/auth/login", { email, password });
}

export async function register(payload: RegisterPayload): Promise<any> {
  return apiPost("/auth/register", payload);
}

export async function fetchMe(): Promise<AuthMe> {
  return apiGet<AuthMe>("/auth/me");
}

// --- Email verification ---
export async function verifyEmail(token: string): Promise<{ ok: boolean }> {
  return apiPost<{ ok: boolean }>("/auth/verify-email", { token });
}

export async function resendVerification(
  email: string
): Promise<{ ok: boolean }> {
  return apiPost<{ ok: boolean }>("/auth/resend-verification", { email });
}

// --- Optional password helpers ---
export async function requestPasswordReset(email: string) {
  return apiPost("/auth/forgot-password", { email });
}

export async function resetPassword(token: string, newPassword: string) {
  return apiPost("/auth/reset-password", {
    token,
    new_password: newPassword,
  });
}
